import React from 'react'
import { findDOMNode } from 'react-dom'

import axios from 'axios'

import NavFeed from '../components/NavFeed'

export default class Blog extends React.Component {
  componentDidMount() {
    document.title = 'Blog'
    this.getPostsFromMedium();
  }

  getPostsFromMedium() {

    var content = findDOMNode(this.refs.jsonContent);
    var rss2jsonAPI = 'https://api.rss2json.com/v1/api.json';
    var mediumRssFeed = 'https://medium.com/feed/@rvroo';

    axios.get(rss2jsonAPI + '?rss_url=' + mediumRssFeed)
      .then(function (response) {
        console.log(response);
        var items = response.data.items;
        for (var i = 0; i < items.length; i++) {
          if (items[i].categories.length > 0) {
            var article = document.createElement("div");
            var articleContent = document.createElement("span");
            articleContent.innerHTML = items[i].content;
            var excerpt = articleContent.getElementsByTagName('p')[0].innerText.replace(/&nbsp;/g, '');;
            article.innerHTML =
                    '<li>' +
                      '<a class="post-link" href="' + items[i].link + '">' +
                        '<h4>' +
                          '<span class="post-title">' + items[i].title + '</span>' +
                          '<span class="post-date">' + items[i].pubDate + '</span>' +
                        '</h4>' +
                        '<span class="post-excerpt">' + excerpt; + '</span>' +
                      '</a>'+
                    '<li>'+
            content.appendChild(article);
          }
        }
      })
      .catch(function (error) {
        console.log(error);
    });
  }



  render() {
    return (
      <div className="blog">
        <br/><br/><br/><br/><br/><br/>
        <section className="container fadeInUp photo">
          <div className="col-6-of-12">
          </div>
          <div className="col-5-of-12 pull-2">
            <h1>/blog</h1>
            {/* <h2>(◕‿◕)</h2> */}
          </div>
        </section>
        <section className="container fadeInUp profile">
          <div className="col-5-of-12">
            <h4>> about this blog:</h4>
          </div>
          <div className="col-7-of-12 link-border">
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Tum Torquatus: Prorsus, inquit, assentior; Qui autem esse poteris, nisi te amor ipse ceperit? De hominibus dici non necesse est. Duo Reges: constructio interrete.
            </p>
          </div>
        </section>
        <section className="container fadeInUp profile">
          <div className="col-5-of-12">
            <h4>> last posts:</h4>
          </div>
          <div className="col-7-of-12">
            <ul className="experience">

              <div className="row" ref="jsonContent"></div>

            </ul>
          </div>
        </section>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/javascripts/pages/Blog.js